let sorters = [];
/**
 * Sorts courses by last logged in date in descending order (most recent first)
 * Courses with null lastLoggedIn dates are placed at the end
 * @param {Array} courses - Array of course objects with lastLoggedIn property
 * @returns {Array} Sorted array of courses
 */
sorters.lastLoggedIn = (courses) => {
  if (!Array.isArray(courses)) return [];
  return [...courses].sort((a, b) => {
    if (a.lastLoggedIn === null && b.lastLoggedIn === null) return 0;
    if (a.lastLoggedIn === null) return 1;
    if (b.lastLoggedIn === null) return -1;
    const dateA = new Date(a.lastLoggedIn).getTime();
    const dateB = new Date(b.lastLoggedIn).getTime();

    return dateB - dateA;
  });
};

sorters.lastloggedin = sorters.lastLoggedIn;

sorters.title = (courses) => {
  if (!Array.isArray(courses)) return [];
  return [...courses].sort((a, b) => a.title.localeCompare(b.title));
};

sorters.createdDate = (courses) => {
  if (!Array.isArray(courses)) return [];
  return [...courses].sort((a, b) => {
    const dateA = new Date(a.createdDate);
    const dateB = new Date(b.createdDate);
    return dateB - dateA;
  });
};

sorters.createddate = sorters.createdDate;

/**
 * Formats the duration into a human-readable string.
 * @param {number} durationHours - The number of hours.
 * @param {number} durationMinutes - The number of minutes.
 * @param {Function} languageContext - A function to get localized strings.
 * @returns {string} The formatted duration string.
 */
const formatDuration = (durationHours, durationMinutes, languageContext) => {
  let time = "";
  if (durationHours || durationMinutes) {
    if (durationHours && durationHours !== 0) {
      time = `${durationHours}h `;
    }
    if (durationMinutes) {
      time += `${durationMinutes}${languageContext("minutesshort")}`;
    }
  }
  return time;
};

/**
 * Determines the button text based on the course status.
 * @param {Object} course - The course object.
 * @param {Function} languageContext - A function to get localized strings.
 * @returns {string} The button text.
 */
const getButtonText = (course, languageContext) => {
  if (course.completed) {
    return languageContext("show");
  }
  if (!course.lastLoggedIn) {
    return languageContext("start");
  }
  return languageContext("continue");
};

/**
 * Calculates the progress percentage.
 * @param {number} completed - The number of completed steps.
 * @param {number} steps - The total number of steps.
 * @returns {number} The progress percentage.
 */
const calculateProgress = (completed, steps) => {
  return Math.round((completed / steps) * 100) || 0;
};

/**
 * Filters programs based on whether they are BT programs.
 * @param {Array} programs - The array of program objects.
 * @param {boolean} isBt - Whether to filter for BT programs.
 * @returns {Array} The filtered array of programs.
 */
const filterBtPrograms = (programs, isBt) => {
  if (!isBt) return programs;
  return programs.filter((program) => program.bt);
};

export {
  sorters,
  formatDuration,
  getButtonText,
  calculateProgress,
  filterBtPrograms,
};
